module.exports = __webpack_public_path__ + "static/media/do.88a82fcc.svg";